import { useTranslation } from "react-i18next";

const VARIANTS = ["strategic", "equity"] as const;

export const EngagementModel = ({ showHeader = true }: { showHeader?: boolean }) => {
  const { t } = useTranslation();
  return (
    <section id="model" className="relative bg-background py-24 md:py-32 border-t border-border overflow-hidden">
      <div className="glass-orbs" aria-hidden />
      <div className="container-x relative z-10">
        {showHeader && (
          <div className="max-w-3xl mb-16">
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
              {t("engagement.eyebrow")}
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-foreground">
              {t("engagement.title")}
            </h2>
            <p className="mt-8 text-base text-muted-foreground leading-relaxed">
              {t("engagement.intro")}
            </p>
          </div>
        )}

        <div className="grid md:grid-cols-2 gap-4">
          {VARIANTS.map((v) => {
            const bullets = t(`engagement.${v}.bullets`, { returnObjects: true }) as string[];
            return (
              <article
                key={v}
                className="glass-wow glass-shimmer rounded-2xl p-10 flex flex-col gap-8 transition-all duration-500"
              >
                <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                  {t(`engagement.${v}.tag`)}
                </p>
                <h3 className="font-display text-2xl md:text-3xl font-light tracking-tight text-foreground">
                  {t(`engagement.${v}.title`)}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t(`engagement.${v}.desc`)}
                </p>
                <ul className="space-y-3 border-t border-border pt-6">
                  {bullets.map((b) => (
                    <li key={b} className="flex gap-3 text-sm text-foreground/80">
                      <span className="text-muted-foreground">·</span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <p className="mt-auto text-xs uppercase tracking-[0.15em] text-foreground border-t border-border pt-6">
                  {t(`engagement.${v}.pricing`)}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
